<template>
  <div class="elementTheme">
    <div class="left">
      <div class="box">
        <el-button>默认按钮</el-button>
        <el-button :disabled="true">默认按钮</el-button>
      </div>
      <div class="box">
        <el-button type="primary">主要按钮</el-button>
        <el-button type="primary" :disabled="true">主要按钮</el-button>
      </div>
      <div class="box">
        <el-button type="text">文字按钮</el-button>
        <el-button type="text" disabled>文字按钮</el-button>
      </div>
      <div class="box">
        <el-checkbox v-model="checked">备选项</el-checkbox>
        <el-checkbox v-model="checked0">备选项</el-checkbox>
        <el-checkbox v-model="checked1" disabled>备选项</el-checkbox>
        <el-checkbox v-model="checked2" disabled>备选项</el-checkbox>
      </div>
      <div class="box">
        <el-radio v-model="radio" label="1">备选项</el-radio>
        <el-radio v-model="radio" label="2">备选项</el-radio>
        <el-radio disabled v-model="radio" label="1">备选项</el-radio>
        <el-radio disabled v-model="radio" label="2">备选项</el-radio>
      </div>
      <div class="box" style="width: 20%">
        <el-input v-model="input" placeholder="请输入内容" :clearable="true"></el-input>
      </div>
      <div class="box" style="width: 20%">
        <el-input v-model="input2" placeholder="请输入内容" :clearable="true"></el-input>
      </div>
      <div class="box" style="width: 20%">
        <el-input v-model="input2" placeholder="请输入内容" :disabled="true" :clearable="true"></el-input>
      </div>
      <div class="box" style="width: 20%">
        <el-select v-model="value" placeholder="请选择" clearable>
          <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="box" style="width: 20%">
        <el-select v-model="value2" placeholder="请选择" clearable disabled>
          <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="right">
      <div>
        <el-button @click="open0">消息提示</el-button>
        <el-button @click="open1">成功提示</el-button>
        <el-button @click="open2">警告提示</el-button>
        <el-button @click="open3">错误提示</el-button>
        <el-button @click="open4">信息确认框</el-button>
        <el-button @click="open5">删除确认框</el-button>
        <el-button @click="open6">错误确认框</el-button>
        <el-button @click="open7">成功确认框</el-button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ElementTheme',
  components: {},
  data () {
    return {
      checked: true,
      checked0: false,
      checked1: false,
      checked2: true,
      radio: '1',
      input: '',
      input2: '有输入内容的',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      value2: '选项1'
    }
  },
  created () {
  },
  methods: {
    open0 () {
      this.$Message('info', '这是一条消息提示!')
    },
    open1 () {
      this.$Message('success', '这是一条消息提示')
    },
    open2 () {
      this.$Message('warning', '这是一条消息提示')
    },
    open3 () {
      this.$Message('error', '这是一条消息提示')
    },
    open4 () {
      this.$Submit({
        confirm: () => {
          console.log(this.checked)
        },
        cancel: () => {
          console.log(this.checked)
        }
      })
    },
    open5 () {
      this.$Delete({
        confirm: () => {
          console.log(this.checked)
        },
        cancel: () => {
          console.log(this.checked)
        }
      })
    },
    open6 () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '正常提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error',
        customClass: 'error'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    open7 () {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '正常提示', {
        showClose: false,
        closeOnClickModal: false,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success',
        customClass: 'success'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .elementTheme{
    width: 100%;
    height: 100%;
    background-color: #2c2d2e;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      width: 50%;
      padding-left: 100px;
    }
    .box{
      width: 100%;
      text-align: left;
      margin-bottom: 20px;
    }
    .right{
      width: 50%;
      display: flex;
      align-items: start;
      flex-wrap: wrap;
    }
  }
</style>
